<template>
  <div>
    <!-- Table Heading Slot -->
    <div class="table-heading mb-0 p-3 flex align-items-center justify-content-between">
      <slot name="table-heading">
        <!-- Default heading if slot not provided -->
        <h1 class="title mb-0 fs-20 fw-500">{{ title }}</h1>
        <button v-if="addButton" class="custom-btn add-new-btn add-secondery" @click="addButton.onClick">
          <i class="fas fa-plus"></i>
          {{ addButton.text || 'إضافة' }}
        </button>
      </slot>
    </div>

    <!-- Table Filters Slot -->
    <div class="table-filters p-3">
      <slot name="filters"></slot>
    </div>

    <!-- Table Body -->
    <div class="table-responsive p-3">
      <table class="table studentsTrips-table">
        <thead class="thead-light">
          <slot name="thead">
            <tr>
              <th v-for="(col, idx) in columns" :key="idx" :width="col.width">{{ col.label }}</th>
              <th v-if="$scopedSlots.actions"></th>
            </tr>
          </slot>
        </thead>
        <tbody>
          <slot name="tbody">
            <tr v-if="!items || items.length === 0">
              <td class="text-center" :colspan="columns.length + ($scopedSlots.actions ? 1 : 0)">
                لا توجد نتائج
              </td>
            </tr>
            <tr v-for="(item, idx) in items" :key="item.id || idx">
              <td v-for="(col, cidx) in columns" :key="cidx">
                <slot :name="col.key" :item="item" :value="item[col.key]">
                  {{ item[col.key] }}
                </slot>
              </td>
              <td v-if="$scopedSlots.actions">
                <slot name="actions" :item="item" />
              </td>
            </tr>
          </slot>
        </tbody>
      </table>
    </div>

    <!-- Pagination Slot -->
    <pagination-teacher
      v-if="pagination && pagination.total > 1"
      :current="pagination.current"
      :total="pagination.total"
      @page-change="changePage"
    />
  </div>
</template>

<script>
import PaginationTeacher from './PaginationTeacher.vue';
export default {
  name: 'BaseTeacherTable',
  components: { PaginationTeacher },
  props: {
    title: String,
    columns: Array,
    items: Array,
    addButton: Object,
    pagination: Object
  },
  methods: {
    changePage(page) {
      if (this.pagination && this.pagination.onPageChange) {
        this.pagination.onPageChange(page);
      }
    }
  }
}
</script>

<style scoped>
.table-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
